import { render, staticRenderFns } from "./StisticUser.vue?vue&type=template&id=172004d1&"
import script from "./StisticUser.vue?vue&type=script&lang=js&"
export * from "./StisticUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports